import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var mean = function mean(values) {
  return values.reduce(function (acc, curr) {
    return acc + curr;
  }, 0) / values.length;
};
export var randomValueBetween = function randomValueBetween(_min, _max) {
  var min = Math.ceil(_min);
  var max = Math.floor(_max);
  return Math.floor(Math.random() * (max - min + 1) + min);
};
export var standardDeviation = function standardDeviation(values) {
  var _mean = mean(values);
  var squaredDifferencesMean = values.reduce(function (acc, curr) {
    return Math.pow(curr - _mean, 2) + acc;
  }, 0) / values.length;
  return Math.sqrt(squaredDifferencesMean);
};
export var deviationFromStandardDeviation = function deviationFromStandardDeviation(values, mean, standardDeviation) {
  return standardDeviation === 0 ? 0 : (values[0] - mean) / standardDeviation;
};
export var fixRoundingErrors = function fixRoundingErrors(values, value) {
  var decimals = Math.max.apply(Math, _toConsumableArray(values.map(function (x) {
    return x.countDecimals();
  })));
  return decimals > 0 ? Math.round(value * decimals * 10) / (decimals * 10) : value;
};